import { ClaimWithCheckoutRelationsDTO } from '@reposit/api-client';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import { Col, Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import { NumberFormat } from '../../constants/number-formats';
import IdentifierValue from '../IdentifierValue';
import InlineEdit from '../InlineEdit';
import InlineTable, { InlineTableItem } from '../InlineTable';
import RepositCard from '../Reposit/RepositCard';

interface ClaimDetailsProps {
  claim: ClaimWithCheckoutRelationsDTO;
  onEditBankTransactionsEnabledAt?: () => void;
  editBankTransactionsEnabledAtDisabledReason?: string;
}

const ClaimDetailsCard = styled(RepositCard)`
  width: 100%;
`;

const ClaimDetails: React.FC<ClaimDetailsProps> = ({
  claim,
  onEditBankTransactionsEnabledAt,
  editBankTransactionsEnabledAtDisabledReason,
}) => {
  const { firstName, lastName, id: createdById } = claim.createdByUser;
  const mediationEnabled = claim.mediationEnabled;

  const items: InlineTableItem[] = [
    {
      key: 'ID',
      value: <IdentifierValue>{claim.id}</IdentifierValue>,
    },
    {
      key: 'Max Liability',
      value: `£${numeral(claim.limit / 100).format(NumberFormat.THOUSANDS_PENCE)}`,
    },
    {
      key: 'Created At',
      value: moment(claim.createdAt).format('DD/MM/YYYY HH:mm:ss'),
    },
    {
      key: mediationEnabled ? 'Original Amount' : 'Claimed Amount',
      value: `£${numeral(claim.originalAmount / 100).format(NumberFormat.THOUSANDS_PENCE)}`,
    },
    {
      key: 'Created By',
      value: `${firstName} ${lastName}`,
      linkTo: `/users/${createdById}`,
    },
    {
      key: 'Auto Charge Status',
      value: claim.autoChargeEnabled ? 'Enabled' : 'Disabled',
    },
    {
      key: 'Organisation',
      value: claim.organization.name,
      linkTo: `/organisations/${claim.organization.id}`,
    },
  ];

  if (mediationEnabled) {
    items.push({
      key: 'Final Amount',
      value: claim.finalAmount ? `£${numeral(claim.finalAmount / 100).format(NumberFormat.THOUSANDS_PENCE)}` : 'N/A',
    });
  }

  if (claim.supplierPaidAt) {
    items.push({
      key: 'Paid At',
      value: moment(claim.supplierPaidAt).format('DD/MM/YYYY'),
    });
  }

  if (claim.legacyId) {
    items.push({
      key: 'Legacy ID',
      value: <IdentifierValue>{claim.legacyId}</IdentifierValue>,
    });
  }

  items.push({
    key: 'Earliest Bank Transfer Import Date',
    value: (
      <span>
        {claim.bankTransactionsEnabledAt
          ? moment(claim.bankTransactionsEnabledAt).format('DD/MM/YYYY')
          : 'Bank transfers not supported'}
        {onEditBankTransactionsEnabledAt ? (
          <InlineEdit onClick={onEditBankTransactionsEnabledAt} disabledReason={editBankTransactionsEnabledAtDisabledReason} />
        ) : null}
      </span>
    ),
  });

  return (
    <ClaimDetailsCard flush title="Claim details" tooltip="lorem">
      <Container>
        <Row>
          <Col lg={12} style={{ padding: 0 }}>
            <InlineTable items={items} />
          </Col>
        </Row>
      </Container>
    </ClaimDetailsCard>
  );
};

export default ClaimDetails;
